import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setAutomationEnabled = {
  name: "setAutomationEnabled" as const,
  input: z.object({ automationId: zExt.objectId(), enabled: z.boolean() }),
  output: z.object({}),
};
